/* eslint-disable */
export function germainApmLoader(servicesUrl, initialProfileName, applicationName, serverHostname) {
        if (monitoredExternally())
            return; // Do nothing if this page is monitored externally
        if (!window.performance) { // Quit as performance API is the minimum to start the monitoring
            reportError("Performance API not available");
            return;
        }
        if (!serverHostname)
            serverHostname = window.location.hostname;
        var loaderArgs = { servicesUrl: servicesUrl, applicationName: applicationName, initialProfileName: initialProfileName, serverHostname: serverHostname };
        var storageKey = "germain-" + applicationName + "-profile"; // Partition by app name in case more than one exists on same origin (domain). Keep in sync with germainApm.reinstallFromProfile and how keys are built by StorageService.
        var hours = 60 * 60 * 1000; // in millis
        var cache = readLocalConfig();
        var cachedScript = cache && cache.agentConfig && { version: cache.agentConfig.scriptVersion, script: cache.agentConfig.monitoringScript };
        if (cache && cache.agentConfig) {
            var ageThreshold = (!cache.agentConfig.enabled || !cache.agentConfig.profileEnabled)
                ? .5 * hours // Update often if disabled, so we can enable again with minimal latency.
                : 16 * hours; // Update seldomly, because a running script can update itself.
            if (cache.timeUpdated < Date.now() - ageThreshold)
                delete cache.agentConfig;
        }
        if (cache && cache.agentConfig) {
            run(cache.agentConfig);
        }
        else {
            updateAndRun();
        }
        function monitoredExternally() {
            try {
                var winPtr = window; // Start with current window in case monitoring is injected more than once
                while (true) {
                    if (winPtr.germainApm)
                        return true;
                    if (winPtr === top)
                        return false;
                    winPtr = winPtr.parent;
                }
            }
            catch (ex) { // Blocked from accessing a cross-origin frame
                return true;
            }
        }
        function readLocalConfig() {
            var json = window.localStorage.getItem(storageKey);
            try {
                if (json)
                    return JSON.parse(json).value;
            }
            catch (ex) { }
        }
        function run(agentConfig) {
            if (!agentConfig.enabled || !agentConfig.profileEnabled)
                return;
            try {
                Function(agentConfig.monitoringScript)();
            }
            catch (ex) {
                reportError("Exception during eval of monitoringScript", ex);
            }
            try {
                Function('loaderArgs', 'agentConfig', agentConfig.initScript)(loaderArgs, agentConfig);
            }
            catch (ex) {
                reportError("Exception during eval of initScript", ex);
            }
        }
        function updateAndRun() {
            if (!servicesUrl)
                return;
            var pathTerms = ['config', 'agent', 'lookup', 'Web UX', serverHostname, applicationName];
            var args = {
                profile: initialProfileName
            };
            if (cachedScript)
                args.hash = cachedScript.version;
            var req = new XMLHttpRequest();
            req.addEventListener('load', then);
            req.open('GET', makeUrl(servicesUrl, pathTerms, args));
            req.setRequestHeader('Cache-Control', 'no-store, max-age=0'); // no-store to prevent caching and maxage to evict previous caching
            req.send();
            function then() {
                var loaded = Date.now();
                var config = { timeUpdated: loaded };
                if (req.status === 200) {
                    try {
                        if (req.responseText) {
                            config.agentConfig = JSON.parse(req.responseText);
                            if (config.agentConfig) {
                                config.agentConfig.browserTime = loaded;
                                if (cachedScript && !config.agentConfig.monitoringScript)
                                    config.agentConfig.monitoringScript = cachedScript.script;
                            }
                        }
                    }
                    catch (ex) { }
                }
                var entry = { version: [], value: config };
                window.localStorage.setItem(storageKey, JSON.stringify(entry));
                if (config.agentConfig)
                    run(config.agentConfig);
            }
        }
        function makeUrl(prefix, pathTerms, args) {
            var url = prefix;
            if (pathTerms.length)
                url += '/' + pathTerms.map(encodeURIComponent).join('/');
            if (Object.keys(args).length)
                url += '?' + Object.keys(args).map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(args[key]); }).join('&');
            return url;
        }
        function reportError(errorLabel, error) {
            sendStatus(false, {
                errorLabel: errorLabel,
                errorDetails: error ? (error instanceof Error ? error.stack : String(error)) : null,
                path: location.href,
                userAgent: navigator.userAgent,
            });
        }
        function sendStatus(isRunning, details) {
            var sourceProfile = cache && cache.agentConfig
                ? cache.agentConfig.profileName + ' v' + cache.agentConfig.scriptVersion
                : initialProfileName;
            var sequence = '';
            if (window.germainApm && window.germainApm.tab) {
                sequence = window.germainApm.tab.getCorrelationId() + '.' + window.germainApm.tab.getTabId();
            }
            var fact = {
                myClassName: 'InternalEvent',
                type: 'GermainAPM:Agent Status',
                timestamp: Date.now(),
                name: 'Web UX',
                value: isRunning ? 1 : 0,
                node: serverHostname,
                engine: applicationName,
                sourceFile: sourceProfile,
                details: typeof details === 'object' ? JSON.stringify(details) : details,
                sequence: sequence
            };
            fact.system = { hostname: serverHostname }; // This should really be target, but InternalEvent only has system
            var url = makeUrl(servicesUrl, ['ingestion', 'beacon', 'fact'], {});
            var body = JSON.stringify([fact]);
            if (navigator.sendBeacon) {
                navigator.sendBeacon(url, body);
            }
            else {
                var req = new XMLHttpRequest();
                req.open('POST', url);
                req.send(body);
            }
        }
    }
    